import { setRoute } from './reducers/set';
import { clearAdditional } from './reducers/clear-additional';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    ROUTES_SET_ROUTE: setRoute,
    ROUTES_CLEAR_ADDITIONAL: clearAdditional,
});
